export default __webpack_public_path__ + "static/media/kendi_sirketim.84d459df.svg";